export const getAffiliateDescription = (affiliateType) => {
    if (!affiliateType) {
        return {
            name: 'Sample budget received',
            description: 'You received a sample budget bonus for referring this creator.',
        };
    }
    switch (affiliateType) {
        case 'Fee_10Percent12Months':
            return {
                name: '10% of platform fees',
                description: 'You get 10% of the platform fees on every sale they make for the first 12 months on Fourthwall.',
            };
        case 'GMV_1Percent12Months':
            return {
                name: '1% of total sales',
                description: 'You get 1% of their total sales their first 12 months on Fourthwall.',
            };
        case 'GMV_1Percent6Months_2PercentNext12':
            return {
                name: '1% of total sales, then 2%',
                description: 'You get 1% of their total sales their first 6 months on Fourthwall. After that, you get 2% of their total sales for the next 12 months.',
            };
        case 'GMV_2Percent6Months_1PercentNext12':
            return {
                name: '2% of total sales, then 1%',
                description: 'You get 2% of their total sales their first 6 months on Fourthwall. After that, you get 1% of their total sales for the next 12 months.',
            };
        case 'GMV_2Percent12Months_1PercentNext6':
            return {
                name: '2% of total sales, then 1%',
                description: 'You get 2% of their total sales their first 12 months on Fourthwall. After that, you get 1% of their total sales for the next 6 months.',
            };
        case 'GMV_2Percent12Months':
            return {
                name: '2% of total sales',
                description: 'You get 2% of their total sales their first 12 months on Fourthwall.',
            };
        case 'Fee_19Percent12Months':
            return {
                name: '19% of platform fees',
                description: 'You get 19% of the platform fees on every sale they make their first 12 months on Fourthwall.',
            };
        default:
            return {
                name: 'Percentage of platform fees',
                description: 'You get a percentage of the platform fees on every sale they make.',
            };
    }
};
